
export default (text = '', params = {}) => {
    if (!text || !params || typeof params !== 'object') return text;

    return Object.entries(params).reduce((t, [key, value]) => {
        if (value === undefined || value === null) return t;

        const safeKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`:${safeKey}\\b`, 'g');

        return t.replace(regex, value);
    }, text);
};

